import React, { useState } from 'react';
import { styles, ODDS_BADGE_COLORS } from './dashboardStyles';

const WelcomeView = ({ events, user, hasParcels, setSelectedEvent, onTabRequest, sbiLookupFailed }) => {
    const openEvents = events.filter(ev => ev.status === 'active' && new Date(ev.endDate) > new Date());
    const clientName = user?.clientId?.name || 'RiverBid';
    const [summaryEvent, setSummaryEvent] = useState(null);

    const subtitle = hasParcels
        ? "Browse currently open opportunities below and start bidding"
        : "To get started, visit My Fields and upload your farm's fields using your SBI number. If you don’t' have an SBI number, you can manually draw in your fields.";

    // Group open events by owning client — farmers with associatedClientIds
    // access can see events from more than one client, so surface which
    // client each auction belongs to. Global events (no clientId) get their
    // own section, sorted last.
    const groupedEvents = openEvents.reduce((groups, ev) => {
        const groupName = (!ev.isGlobal && ev.clientId?.name) ? ev.clientId.name : 'Global';
        if (!groups[groupName]) groups[groupName] = [];
        groups[groupName].push(ev);
        return groups;
    }, {});
    const groupNames = Object.keys(groupedEvents).sort((a, b) => {
        if (a === 'Global') return 1;
        if (b === 'Global') return -1;
        return a.localeCompare(b);
    });

    return (
    <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <div style={{ ...styles.card, textAlign: 'center', padding: '30px' }}>
            <h1 style={{ margin: 0, ...styles.h1, fontSize: '1.8rem' }}>Welcome to RiverBid for {clientName}</h1>
            <p style={{ ...styles.textMuted, marginTop: '10px' }}>{subtitle}</p>
            {sbiLookupFailed && (
                <div style={{ marginTop: '10px' }}>
                    <span style={{
                        ...styles.oddsBadge,
                        backgroundColor: ODDS_BADGE_COLORS.failed.bg,
                        borderColor: ODDS_BADGE_COLORS.failed.border,
                        color: ODDS_BADGE_COLORS.failed.color,
                    }}>
                        We couldn't automatically load the SBI field boundaries supplied at Registration — visit "My Fields" to try again.
                    </span>
                </div>
            )}
        </div>

        <div style={styles.card}>
            <h3 style={{ marginTop: 0, ...styles.hHighlight }}>Open Events</h3>
            {openEvents.length === 0 ? (
                <p style={styles.textMuted}>There are no open events available right now. Please check back later.</p>
            ) : (
                groupNames.map(groupName => (
                    <div key={groupName} style={{ marginBottom: '25px' }}>
                        <h4 style={styles.clientSectionHeader}>{groupName}</h4>
                        <div style={styles.eventCardGrid}>
                            {groupedEvents[groupName].map(ev => (
                                <div key={ev._id} style={styles.eventCard}>
                                    <div style={styles.eventCardHeader}>{ev.name}</div>
                                    <div style={styles.eventCardMeta}>
                                        <span>Closes {new Date(ev.endDate).toLocaleDateString('en-GB')}</span>
                                    </div>
                                    <div style={styles.eventCardActions}>
                                        <button
                                            onClick={() => { setSelectedEvent(ev._id); onTabRequest('dashboard'); }}
                                            style={{ ...styles.btnPrimary, width: '100%' }}
                                        >
                                            Manage Bids
                                        </button>
                                        <div style={styles.eventCardSecondaryRow}>
                                            <button
                                                onClick={() => setSummaryEvent(ev)}
                                                style={styles.eventCardSecondaryBtn}
                                            >
                                                Event Summary
                                            </button>
                                            {ev.eventSummaryUrl && (
                                                <a
                                                    href={ev.eventSummaryUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ ...styles.eventCardSecondaryBtn, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                >
                                                    Event Webpages
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))
            )}
        </div>

        {summaryEvent && (
            <div style={styles.modalOverlay}>
                <div style={{ ...styles.modalBox, maxWidth: '600px' }}>
                    <h3 style={{ marginTop: 0, ...styles.h2 }}>{summaryEvent.name} — Event Summary</h3>
                    <p style={{ whiteSpace: 'pre-wrap', color: '#475569' }}>
                        {summaryEvent.eventSummary || 'No summary provided for this event.'}
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <button onClick={() => setSummaryEvent(null)} style={styles.btnPrimary}>Close</button>
                    </div>
                </div>
            </div>
        )}
    </div>
    );
};

export default WelcomeView;
